export default (array, { keyMapper = ({ index }) => index, valueMapper = ({ item }) => item }) => {
  return (array || []).reduce((mappedObject, item, index) => {
    mappedObject[keyMapper({ index, item })] = valueMapper({ item, index });
    return mappedObject;
  }, {});
};
